<template>
    <div class="form-group">
        <slot name="header" />
        <input 
            :id="id.ID()"
            class="form-check-inline"
            type="checkbox" 
            :checked="value" 
            @input="$emit('input', $event.target.checked)" 
            :aria-label="label"
        />
        <label :class="{'sr-only': srOnly}" :for="id.ID()" class="mb-0">
            <slot name="label">{{ label }}</slot>
        </label>
        <div>
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
import id from 'src/modules/uuid.js';

export default {
    props: {
        value: Boolean,
        label: {
            type: String,
            required: true,
        },
        srOnly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            id: new id()
        }
    }
}
</script>